export const COMPACT_UNITS = ['', 'K', 'M', 'B', 'T'];
